import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import AppLayout from '../layouts/AppLayout.vue';

import AuthLayout from '../layouts/AuthLayout.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'events' },
  },
  {
    name: 'base',
    path: '/',
    component: AppLayout,
    redirect: { name: 'events' },
    children: [
      {
        name: 'rewards',
        path: 'rewards',
        component: () => import('@/pages/rewards/RewardsPage.vue'),
      },
      {
        name: 'settings',
        path: 'settings', 
        component: () => import('@/pages/settings/Settings.vue'),
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('@/pages/users/UsersPage.vue'),
      },
      {
        name: 'event-pools',
        path: 'event-pools',
        component: () => import('@/pages/event-pools/EventPoolsPage.vue'),
      },
      {
        name: 'event-pools-detail',
        path: 'event-pools/:id',
        component: () => import('@/pages/event-pools/EventPoolDetail.vue'),
      },
      {
        name: 'event-to-event-pools',
        path: 'event-to-event-pools',
        component: () => import('@/pages/event-to-event-pools/EventToEventPoolsPage.vue'),
      },
      {
        name: 'events',
        path: 'events',
        component: () => import('@/pages/events/EventsPage.vue'),
      },
      {
        name: 'add-event-to-pool',
        path: 'events/:poolId',
        component: () => import('@/pages/events/AddEventToPool.vue'),
      },
      {
        name: 'event-teams',
        path: 'event-teams',
        component: () => import('@/pages/event-teams/EventTeamsPage.vue'),
      },
      {
        name: 'single-event-forecasts',
        path: 'single-event-forecasts',
        component: () => import('@/pages/single-event-forecasts/SingleEventsPage.vue'),
      },
      {
        name: 'single-statistics',
        path: 'single-statistics',
        component: () => import('@/pages/single-statistics/SingleStatisticsPage.vue'),
      },
      {
        name: 'countries',
        path: 'countries',
        component: () => import('@/pages/countries/CountriesPage.vue'),
      },
      {
        name: 'competitions',
        path: 'competitions',
        component: () => import('@/pages/competitions/CompetitionsPage.vue'),
      },
      {
        name: 'teams',
        path: 'teams',
        component: () => import('@/pages/teams/TeamsPage.vue'),
      },
    ],
  },
  {
    path: '/login',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: '',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    } else {
      window.scrollTo(0, 0);
    }
  },
  routes,
});

export default router;
